import { AssetVersion } from '../../../../clients/design_assets/types';

export type SortableDesignAsset = {
  id?: number;
  name?: string;
  fileName?: string;
  file_name?: string;
  url?: string;
  fileType?: string;
  versions?: AssetVersion[];
};

export const versionsForAsset = (
  asset: SortableDesignAsset
): AssetVersion[] =>
  asset.versions?.length
    ? asset.versions
    : [
        {
          version: 1,
          createdAt: '',
          url: asset.url || '',
          fileName: asset.fileName || asset.name || '',
          fileType: asset.fileType || ''
        }
      ];

export const displayedAssetVersion = (
  asset: SortableDesignAsset,
  selected?: AssetVersion | 'all'
) => {
  const versions = versionsForAsset(asset);
  return selected && selected !== 'all'
    ? versions.find(version => version.version === selected.version) ||
        versions.find(version => version.version === 1) ||
        versions[0]
    : versions[versions.length - 1];
};

export const getAssetTitle = (asset: SortableDesignAsset): string =>
  asset.name || asset.fileName || asset.file_name || 'Untitled design';

export const sortDesignGroupAssets = <T extends SortableDesignAsset>(
  assets: T[]
): T[] =>
  assets.slice().sort((assetA, assetB) => {
    const titleComparison = getAssetTitle(assetA).localeCompare(
      getAssetTitle(assetB),
      undefined,
      { sensitivity: 'base' }
    );

    if (titleComparison !== 0) return titleComparison;

    return (assetA.id || 0) - (assetB.id || 0);
  });
